import { Observable } from 'rxjs'
import { Query } from '../../../common/api/Query'
import { ItemList } from '../../../common/models/ItemList'
import { Container, IInit } from '../../../common/container/Container'
import { IStatusService } from '../../../common/status/StatusService'
import { STATUS_SERVICE_KEY } from '../../../container/app'
import { Statistics } from '../models/Statistics'
import { StatisticsDTO } from '../models/StatisticsDTO'
import { IUserHeartApi } from '../api/UserHeartApi'

type Props = {
  apiKey: symbol
}

export interface IUserHeartService extends IInit {
  getByID(id: string): Observable<Statistics | undefined>

  getFilteredList(q: Query<Statistics>): Observable<ItemList<Statistics>>

  add(e: StatisticsDTO): Observable<Statistics | undefined>

  update(e: StatisticsDTO): Observable<Statistics | undefined>

  delete(id: string): Observable<boolean>
}

export class UserHeartService implements IUserHeartService {
  private readonly _apiKey: symbol
  private _container!: Container
  private _api!: IUserHeartApi
  private _statusService!: IStatusService

  constructor(p: Props) {
    this._apiKey = p.apiKey
  }

  init(c: Container) {
    this._container = c
    this._api = this._container.get<IUserHeartApi>(this._apiKey)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
  }

  add(e: StatisticsDTO): Observable<Statistics | undefined> {
    return this._api.add(e)
  }

  delete(id: string): Observable<boolean> {
    return this._api.delete(id)
  }

  getByID(id: string): Observable<Statistics | undefined> {
    return this._api.getByID(id)
  }

  getFilteredList(q: Query<Statistics>): Observable<ItemList<Statistics>> {
    return this._api.getFilteredList(q).pipe()
  }

  update(e: StatisticsDTO): Observable<Statistics | undefined> {
    return this._api.update(e)
  }
}
